import { render, staticRenderFns } from "./LancamentosTab.vue?vue&type=template&id=70fb337c&"
import script from "./LancamentosTab.vue?vue&type=script&lang=js&"
export * from "./LancamentosTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports